export default "__VITE_ASSET__DnlQpGt0__"